import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { CreateTrunkForm } from '@components/Capacity/Trunks/CreateTrunkForm';
import { TrunksTable } from '@components/Capacity/Trunks/TrunksTable';
import { capacityApi } from '@reducers/capacity/capacity';

export const Trunks = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Row className="mb-3">
        <Col md={10}>
          <TrunksTable
            useData={capacityApi.useGetUserTrunksQuery}
            setVisible={setVisible}
            visible={visible}
          />
        </Col>
        <Col md={2}>
          <p className="fw-bold">Add extra trunk channels</p>
          <p>
            If you want to increase the number of channels of a trunk, please
            send an email to <b>noc@didxl.com</b>
          </p>
        </Col>
      </Row>
      {visible ? (
        <Row>
          <Col md={10}>
            <Card>
              <Card.Header className="bg-didxl text-white">
                Create new trunk
              </Card.Header>
              <Card.Body>
                <CreateTrunkForm />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : null}
    </>
  );
};
